import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
// import { useWeb3Modal } from '@web3modal/wagmi/react';
import WalletConnectWalletInfo from '../WalletInfo/WalletConnectWalletInfo';
import { extractAddress } from '../helper';
import { useWagmiConfig } from '../../../../WalletConnectContext';
import { useAppKit } from "@reown/appkit/react";
import { useAccount } from 'wagmi';
import { useDisconnect } from "@reown/appkit/react";
import { IoIosWarning } from "react-icons/io";

export default function WalletConnectWalletConfig({
  allBalance,
  selectedChain,
  selectedToken,
  setAddress,
}) {

  const { disconnect } = useDisconnect();
  const config = useWagmiConfig();
  const { open: openModal, close: closeModal, } = useAppKit();
  const { address, isConnected } = useAccount();
  const [isShowModal, setIsShowModal] = useState(false);

  useEffect(() => {
    if (address) {
      setAddress(address);
    }
  }, [address])

  const _disconnect = async () => {
    await disconnect();
    setAddress("");
  }

  const handleClose = () => {
    setIsShowModal(false);
    openModal();
  }


  return (
    <div>
      <Modal className='network-modal' size="md" centered show={isShowModal} onHide={handleClose}>
        <Modal.Body>
          <div>
            <h2 className='mb-4 mt-2 d-flex align-items-center gap-2 justify-content-center text-body'>
              <b>Check Your Network</b >
              <IoIosWarning size={30} color='#FFC232' />
            </h2>
            <p className='text-muted text-center'>
              To ensure a smooth transaction experience, please make sure <b className="text-dark">Your wallet</b> is connected to the
              <b className="text-dark"> {selectedChain?.chainName}</b> network.
            </p>
            <p className='text-muted text-center mb-0'>
              Mismatched networks may lead to failed transactions or unexpected errors.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button className='px-4' variant="primary" onClick={handleClose}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="title-block">
        <strong >
          {
            address ? `Wallet address ${extractAddress(address)}` : " Connect your wallet"
          }
        </strong>
      </div>
      <div className='mt-3'>
        <div className="p-3 text-dark">
          {
            !address ?
              <div>
                <p className='mb-4 wallet-info-text'>
                  You have selected a network and token. Now, connect your wallet using a secure connection via WalletConnect. This method supports both mobile and desktop wallets, allowing you to quickly interact with the selected network.
                  <br />To proceed press the <b>Connect Wallet</b> button below.
                </p>
                <Button variant="primary w-100 shadow" onClick={() => setIsShowModal(true)}>Connect Wallet</Button>
                {/* <appkit-button /> */}
              </div> :
              <div>
                {/* <w3m-button balance loadingLabel /> */}
                <WalletConnectWalletInfo
                  allBalance={allBalance}
                  selectedChain={selectedChain}
                  selectedToken={selectedToken}
                />
                <div className="d-flex justify-content-end mt-3">
                  <Button size='sm' variant="danger" onClick={_disconnect}>Disconnect Wallet</Button>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}

